import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { CABINET_SLUG } from '../../config';


const UserMenu = ({ lang, isAuth, avatar, full_name, currency, balance }) => {
  const root = '/' + lang + '/' + CABINET_SLUG + '/'
  if (isAuth){
    return <div className="d-flex align-items-center cabinet-top-user-menu">
      <div className='d-flex mr-1'>
        <img src={ avatar } alt="Avatar" className="mr-1 rounded-circle"/>
      </div>
      <div className='d-flex mr-1'>{ full_name }</div>
      <div className='d-flex'>
        <div className="dropdown text-right flex-column">
          <a className="dropdown-toggle font-weight-bold text-orange" href="#" id="cabinetMoneyDropdown" role="button"
             data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            { currency } { balance }
          </a>
          <div className="dropdown-menu" aria-labelledby="cabinetMoneyDropdown">
            <a className="dropdown-item" href={ root + 'balance/addfunds' + '/' }>{ gettext('Пополнить Баланс') }</a>
            <a className="dropdown-item" href={ root + 'balance/history' + '/' }>
              { gettext('История Пополнений') }
            </a>
          </div>
        </div>

      </div>
    </div>
  }

  return null;
};

UserMenu.propTypes = {
  lang: PropTypes.string.isRequired,
  isAuth: PropTypes.bool.isRequired,
  currency: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  full_name: PropTypes.string.isRequired,
  balance: PropTypes.string.isRequired,
}

let mapStateToProps = (state) => {
  return {
    isAuth: state.auth.isAuth,
    lang: state.auth.lang,
    currency: state.auth.currency,
    balance: state.auth.balance,
    avatar: state.auth.avatar,
    full_name: state.auth.full_name,
  }
};

export default compose(
  connect(mapStateToProps, {  }),
)(UserMenu);


